import { forwardRef, type InputHTMLAttributes } from 'react';

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  prefix?: string;
  suffix?: string;
}

/** docs/spec/06 §2 Field: caption label, 40 px box, accent border on focus. */
export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(
  { label, prefix, suffix, className = '', id, ...rest },
  ref,
) {
  return (
    <label className={`flex flex-col gap-1 ${className}`} htmlFor={id}>
      {label ? <span className="t-caption text-muted">{label}</span> : null}
      <span className="flex min-h-10 items-center gap-1.5 rounded-sm border border-border bg-surface2 px-3 focus-within:border-accent">
        {prefix ? <span className="t-body text-muted">{prefix}</span> : null}
        <input
          ref={ref}
          id={id}
          {...rest}
          className="min-w-0 flex-1 bg-transparent text-[15px] text-text outline-none placeholder:text-muted selection:bg-accent selection:text-accent-ink"
        />
        {suffix ? <span className="t-caption text-muted">{suffix}</span> : null}
      </span>
    </label>
  );
});
